import DesUsePartViewModel from 'viewmodel/DesUsePartViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';

export default class DesUsePart extends DesBaseCatalogAcc {
    constructor() {
        super(DesUsePartViewModel);
    }

    get libraryId() {
        return this.getAttribute('library-id') || this.getAttribute('libraryid');
    }

    get locale() {
        return this.getAttribute('locale') || 'en_US';
    }

    getProps() {
        return {
            libraryid: this.libraryId
        };
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'locale', 'library-id', 'libraryid'];
    }
}

if (!window.customElements.get('des-use-part')) {
    window.customElements.define('des-use-part', DesUsePart);
}
